import React, { useEffect } from "react";
import { Form } from "antd";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router";
import { asMoney } from "../../common/constants/Helpers";
import { RootState } from "../../store";
import { usePostPaymentInsertMutation, usePostPaymentMutation, usePrePaymentInsertMutation, usePostInfintechPaymentMutation, useGetPaymentConfigMutation } from "../../state/globalApi";
import { LookupRequest } from "../../models/lookup-request";
import { buildPaymentConfigRequest, paymentRequest, prePaymentRequest, session } from "../../state/connect-api";
import axios from "axios";
import getConfigs from "../../GetConfigs";
import { setActiveTransactionId } from "../../state/globalStore";

interface StateType {
  state: {
    fromPage?: string;
  };
  key: string;
  pathname: string;
  search: string;
  hash: string;
}

const useTrafficPayment = () => {
  const [disableInput, setDisableInput] = useState<boolean>(true);
  const [TSPAccepted, setTSPAccepted] = useState<boolean>();
  const { casePayment: paymentData, activeCaseNumber } = useSelector((state: RootState) => state.global);
  enum AmountToPay {
    CURRENT_BALANCE = 1,
    MINIMUM_PAYMENT = 2,
    OTHER_AMOUNT = 3
  }
  const [form] = Form.useForm();
  const [amountData, setAmountData] = useState<boolean>(true);
  const [amount, setAmount] = useState<number>();
  const [res, setRes] = useState<any>();
  const history = useNavigate();
  const location = useLocation();
  const [postPay, { data, isLoading: paymentTokenLoading }] = usePostPaymentMutation();
  const [token, setToken] = useState<string>();
  const [prePaymentInsert, { data: preInsertData, isLoading: preInsertLoading }] = usePrePaymentInsertMutation();
  const [postPaymentInsert, { data: postInsertData, isLoading: postInsertLoading }] = usePostPaymentInsertMutation();
  const [postPaymentInfintech, { data: postInfintechData, isLoading: infintechLoading }] = usePostInfintechPaymentMutation();
  const [getConfig] = useGetPaymentConfigMutation();
  const dispatch = useDispatch();
  const [transactionId, setTransactionId] = useState<string>();
  const [paymentType, setPaymentType] = useState<string>();
  const configurations = getConfigs(["activePayProcessor", "authorizeSandbox"]);
  const authorizeSandbox = configurations.authorizeSandbox == "true";
  useEffect(() => {
    if (transactionId && amount) {
      handleMakePayment(amount, TSPAccepted);
    }
  }, [transactionId]);

  const paymentColumn = [
    { title: "Description", key: "description", dataIndex: "DESCRIPTION" },
    { title: "Total Amount", key: "totalAmount", dataIndex: "TOTAL_AMOUNT", ...asMoney },
    { title: "Amount Due", key: "amountDue", dataIndex: "PAYABLE_AMOUNT", ...asMoney }
  ];

  const handleContinue = async () => {
    const values = await form.validateFields();
    setAmount(values.amount);
    setTSPAccepted(values.TSPAccepted);
    setAmountData(!amountData);
    handlePrePayment(values.amount, values.TSPAccepted);
  };

  const handleView = (eve) => {
    const amountData = form.getFieldValue("amount");
    if (eve === AmountToPay.OTHER_AMOUNT) {
      form.setFieldsValue({ amount: "" });
      setDisableInput(false);
    } else if (eve === AmountToPay.CURRENT_BALANCE) {
      form.setFieldsValue({ amount: paymentData?.MAIN[0]?.TOTOWED });
      setDisableInput(true);
    } else {
      form.setFieldsValue({ amount: Number(paymentData?.MAIN[0]?.TOTMIN) === 0 ? 1 : paymentData?.MAIN[0]?.TOTMIN });
      setDisableInput(true);
    }
    setAmount(amountData);
  };

  const handleCancel = () => {
    const stateObject: StateType = { ...location };
    history(stateObject.state.fromPage === "TCL" ? "/lookup/detail" : "/warrant/detail", { replace: true, state: { fromPage: stateObject.state.fromPage } });
  };

  const handleMakePayment = async (amountDue, TSPAccepted) => {
    if (transactionId == undefined) {
      handlePrePayment(amountDue, TSPAccepted);
      return;
    }
    switch (configurations.activePayProcessor.toLowerCase()) {
      case "bridge":
        return bridgePayment(amountDue);
      case "infintech":
        return infintechPayment(amountDue);
      case "paypal":
        return payPalPayment(amountDue);
      case "authorize":
        return authorizePayment(amountDue);
      default:
        console.log("Payment not configured.");
    }
  };
  const bridgePayment = async (amountDue) => {
    const bridgeConfigRequestItems = buildPaymentConfigRequest("bridge");
    const configRequest = await getConfig(bridgeConfigRequestItems).unwrap();
    const configValues = configRequest.Data;
    const configObject = configValues.reduce((acc, item) => {
      return {
        ...acc,
        [item.ConfigName]: item.ConfigValue
      };
    }, {});

    const form = document.createElement("form");
    form.method = "POST";
    form.action = configObject.payProcessorPayUrl;
    form.target = "_blank";
    const values = {
      PayerID: activeCaseNumber,
      AmountOwed: amountDue,
      ClientID: configObject.ClientID,
      TransactionReference: transactionId,
      SessionID: session,
      payPostBack: configObject.payPostBack,
      payProcessorAcctID: configObject.payProcessorAcctID,
      payProcessorKey: configObject.payProcessorKey,
      MerchantID: paymentType == "BOND" ? configObject.bondsMerchantId : configObject.TRCRMerchantId

    };
    Object.keys(values).forEach((key) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = values[key];
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
  };
  const infintechPayment = async (amountDue) => {
    const infintechOrderId = `${activeCaseNumber}-${transactionId}-${session}`;
    const JsonBody = {
      clientId: "", //infintechConfig.payProcessorClientID,
      orderId: infintechOrderId,
      preSharedKey: "", //infintechConfig.payProcessorPreSharedKey,
      redirectUrl: "", //"http://web1.civicacmi.com/Court/Default.aspx",
      principalAmount: amountDue,
      postUrl: "", //infintechConfig.postUrl,
      cancelUrl: "", //infintechConfig.cancelUrl,
      emailReceipt: "", //infintechConfig.emailReceipt,
      emailForm: "", //infintechConfig.emailForm,
      stationId: "", //`${infintechConfig.appid}-${infintechConfig.client_id}`,
      clerkId: null,
      cancelTimeout: "99999",
      items: [
        {
          itemId: "CT",
          name: `${activeCaseNumber} Court Payment`,
          quantity: "1",
          amount: amount
        }
      ]
    };

    const response = await postPaymentInfintech(JsonBody).unwrap();
    window.location.href = response.url;

    return response;
  };
  const payPalPayment = async (amountDue) => {
    const payPalConfigRequestItems = buildPaymentConfigRequest("payPal");
    const configRequest = await getConfig(payPalConfigRequestItems).unwrap();
    const configValues = configRequest.Data;
    const configObject = configValues.reduce((acc, item) => {
      return {
        ...acc,
        [item.ConfigName]: item.ConfigValue
      };
    }, {});
    const formValues = {
      LOGIN: configObject.payProcessorAcctID,
      PARTNER: configObject.partner,
      TYPE: configObject.type,
      AMOUNT: amountDue,
      user1: activeCaseNumber,
      user5: configObject.user5,
      user7: configObject.applicationId,
      user6: configObject.siteId,
      user8: transactionId,
      user9: session,
      user10: null
    };

    const form = document.createElement("form");
    form.method = "POST";
    form.action = "https://pilot-payflowlink.paypal.com/";
    form.target = "_blank";
    Object.keys(formValues).forEach((key) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = formValues[key];
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
  };
  const authorizePayment = async (amountDue) => {
    const body = {
      getHostedPaymentPageRequest: {
        merchantAuthentication: {
          name: "",
          transactionKey: ""
        },
        transactionRequest: {
          transactionType: "authCaptureTransaction",
          amount: `${amountDue}`,
          lineItems: {
            lineItem: {
              itemId: "1",
              name: "Court Payment",
              quantity: "1",
              unitPrice: `${amountDue}`
              //description: "Court Payment"
            }
          },
          customer: {
            id: activeCaseNumber
          },
          userFields: {
            userField: [
              {
                name: "App",
                value: "CT"
              },
              {
                name: "Case",
                value: `${activeCaseNumber}`
              },
              {
                name: "trans",
                value: `${transactionId}`
              }
            ]
          }
          //billTo: {
          //  firstName: "",
          //  lastName: "",
          //  company: "",
          //  address: "",
          //  city: "",
          //  state: "",
          //  zip: "",
          //  country: "US"
          //}
        },
        hostedPaymentSettings: {
          setting: [
            {
              settingName: "hostedPaymentReturnOptions",
              settingValue: ""
            },
            {
              settingName: "hostedPaymentButtonOptions",
              settingValue: ""
            },
            {
              settingName: "hostedPaymentStyleOptions",
              settingValue: ""
            },
            {
              settingName: "hostedPaymentPaymentOptions",
              settingValue: ""
            },
            {
              settingName: "hostedPaymentSecurityOptions",
              settingValue: ""
            },
            {
              settingName: "hostedPaymentShippingAddressOptions",
              settingValue: ""
            },
            {
              settingName: "hostedPaymentBillingAddressOptions",
              settingValue: ""
            },
            {
              settingName: "hostedPaymentCustomerOptions",
              settingValue: ""
            },
            {
              settingName: "hostedPaymentOrderOptions",
              settingValue: ""
            },
            {
              settingName: "hostedPaymentIFrameCommunicatorUrl",
              settingValue: ""
            }
          ]
        }
      }
    };
    const response = await postPay(body).unwrap();
    setRes(response.token);
    return response;
  };

  const handlePrePayment = async (amountDue, TSPAccepted) => {
    setAmount(amountDue);
    setTSPAccepted(TSPAccepted);
    const lookupRequest: LookupRequest = prePaymentRequest(activeCaseNumber, `${amountDue}`, TSPAccepted ? "BOND" : paymentData?.MAIN[0]?.PaymentType, TSPAccepted ? "TSP" : "" );
    const prepaymentRequest = await prePaymentInsert(lookupRequest).unwrap();
    dispatch(setActiveTransactionId(preInsertData?.MAIN[0]?.PAY_TRANSID));
    dispatch(setActiveTransactionId(prepaymentRequest?.MAIN[0]?.PAY_TRANSID));
    setTransactionId(preInsertData?.MAIN[0]?.PAY_TRANSID);
    setTransactionId(prepaymentRequest?.MAIN[0]?.PAY_TRANSID);
    setPaymentType(prepaymentRequest?.MAIN[0]?.PAYMENTTYPE);
    return transactionId;
  };

  const handlePostPayment = async (responseData) => {
    const remoteAddress = await axios.get("https://geolocation-db.com/json/");
    //CV before for civil, change transaction
    const lookupRequest: LookupRequest = paymentRequest(transactionId, activeCaseNumber, responseData?.totalAmount, "", responseData?.dateTime, remoteAddress?.data.IPv4);
    //const postpay = await postPaymentInsert(lookupRequest).unwrap();
  };

  return {
    paymentColumn,
    amountData,
    handleContinue,
    form,
    AmountToPay,
    handleView,
    disableInput,
    paymentData,
    amount,
    handleCancel,
    handleMakePayment,
    token,
    paymentTokenLoading,
    res,
    handlePrePayment,
    preInsertLoading,
    handlePostPayment,
    authorizeSandbox,
    TSPEligible: paymentData?.MAIN[0]?.PAY_MESSAGE == "DEL1",
    TSPAccepted
  };
};

export default useTrafficPayment;
